import React, {useState, useEffect} from 'react';
import {Box, Text, ActionIcon} from '@mantine/core';
import {Sheet} from 'react-modal-sheet';
import {IconX} from '@tabler/icons-react';

type MobileSheetProps = {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    snapPoints?: number[];
    initialSnap?: number;
};

export const MobileSheet = ({
    isOpen,
    onClose,
    title,
    children,
    snapPoints = [0, 0.95],
    initialSnap = 1,
}: MobileSheetProps) => {
    const [internalOpen, setInternalOpen] = useState(isOpen);

    useEffect(() => {
        if (isOpen) {
            setInternalOpen(true);
        }
    }, [isOpen]);

    const handleClose = () => {
        setInternalOpen(false);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    return (
        <Sheet
            isOpen={internalOpen}
            onClose={handleClose}
            snapPoints={snapPoints}
            initialSnap={initialSnap}
        >
            <Sheet.Container
                style={{
                    backgroundColor: 'var(--mantine-color-body)',
                    zIndex: 200,
                }}
            >
                <style>{`
                    .react-modal-sheet-drag-indicator {
                        display: none !important;
                    }
                `}</style>
                {title && (
                    <Sheet.Header>
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px 16px',
                                borderBottom: '1px solid var(--mantine-color-default-border)',
                            }}
                        >
                            <Text size="lg" fw={600}>{title}</Text>
                            <ActionIcon
                                variant="subtle"
                                size="lg"
                                onClick={handleClose}
                            >
                                <IconX size={24} />
                            </ActionIcon>
                        </Box>
                    </Sheet.Header>
                )}
                <Sheet.Content
                    disableDrag={true}
                    style={{
                        backgroundColor: 'var(--mantine-color-body)',
                        paddingBottom: 40,
                        overflowY: 'scroll',
                        WebkitOverflowScrolling: 'touch',
                    }}
                >
                    {children}
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={handleClose} />
        </Sheet>
    );
};
